import { render, staticRenderFns } from "./prechargeMgt.vue?vue&type=template&id=bf607e98&scoped=true&"
import script from "./prechargeMgt.vue?vue&type=script&lang=js&"
export * from "./prechargeMgt.vue?vue&type=script&lang=js&"
import style0 from "./prechargeMgt.vue?vue&type=style&index=0&id=bf607e98&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf607e98",
  null
  
)

export default component.exports